<div class="container" [ngClass]="{ visibility: exibir }" (click)="fechar()">
  <div class="popup" [ngClass]="definirClasse()" (click)="pararPropagacao($event)">
    <div class="popup__fechar" *ngIf="exibirBotaoFechar">
      <div class="fechar" (click)="fechar()">
        <img
          class="fechar__icone"
          src="assets/images/icons/x.png"
        />
      </div>
    </div>
    <ng-content></ng-content>
  </div>
</div>
